module.exports = __webpack_public_path__ + "static/media/Rodger-Brown_160px.b086b3e4.jpg";